<template>
  <div id="page_01" class="page">
    <div class="content">
      <div id="logo_area">
        <img src="@/assets/img/page_01_logo.png" />
      </div>
      <div id="btn_area">
        <a id="btn_contact" class="btn" 
            v-scroll-to="{
                element: '#page_08', 
                container: 'body'
                }">
          가맹점 문의
        </a>
        <a id="btn_online_shop" class="btn" href="https://www.specimen.co.kr" target="_blank">
          Online Shop
        </a>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Page01'
}
</script>

<style scoped>
  .content{background-image:url("../assets/img/bg_page_01.jpg"); padding-top:2.95rem;}
  #logo_area{text-align:center;}
  #logo_area>img{width:20.4rem; height:auto;}
  #btn_area{margin: 0 auto;margin-top:3.842rem;margin-bottom:4.16rem;width:14.96rem;}
  #btn_area>.btn{color:#fff;border: 0.1rem solid #fff; width:5.96rem; height:1.9rem;font-size:0.84rem;text-align:center;line-height:1.9rem;cursor:pointer; display: inline-block;}
  #btn_contact{margin-right:2.24rem;}

  @media (max-width:720px) {
    .content{padding-top:11.15rem;padding-bottom:11.2rem;}
    #btn_online_shop{margin-top:1.5rem !important;}
    #btn_area{width:100%;margin-top:5.842rem;}
    #btn_area>.btn{display:block;margin:0 auto;width:12rem;height:2.5rem;line-height:2.5rem;}
    #logo_area>img{width:18rem;}
  }
</style>
